import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './redux/index.ts';
import('./index.less');
import App from './App.tsx';

createRoot(document.getElementById('root')!, {
    onUncaughtError(error) {
        // 当错误未被任何错误边界捕获时调用
        console.error('Uncaught error:', error);
    }
}).render(
    <StrictMode>
        <Provider store={store}>
            <App />
        </Provider>
    </StrictMode>,
);
